import React from "react";

import Centile from "pages/customer/tools/location/filters/targets/Centile";
import CentileMetric from "pages/customer/tools/location/filters/targets/CentileMetric";

import { selectFeatureFlags } from "modules/featureFlags/featureFlagsSlice";
import {
    selectCandidateComparatorStores,
    selectCandidateTarget,
    selectAggregatedDirectCompetitors,
    selectRetailCentresCentiles,
    selectStoreCategoryCentilesMetrics,
    setCandidateTarget
} from "modules/customer/tools/location/filters/filtersSlice";
import { useAppDispatch, useAppSelector } from "store";
import numberFormatter from "utils/numberFormatter";

const FootfallLevel: React.FC = () => {
    const dispatch = useAppDispatch();
    const featureFlags = useAppSelector(selectFeatureFlags);
    const enableFootfallNew = featureFlags.enableCustomerToolsLocationFootfallNew;
    const candidateComparatorStores = useAppSelector(selectCandidateComparatorStores);
    const retailCentresCentiles = useAppSelector(selectRetailCentresCentiles);
    const comparatorStoresCentiles = candidateComparatorStores.map(store => {
        const retailCentreCentile = retailCentresCentiles.find(rcc => rcc.retailCentreId === store.retailCentre.id)?.footfall ?? 0;
        return {
            storeName: store.name,
            centileValue: retailCentreCentile
        };
    });
    const aggregatedDirectCompetitors = useAppSelector(selectAggregatedDirectCompetitors);
    const aggregatedDirectCompetitorCentiles = aggregatedDirectCompetitors.map(item => ({
        storeName: item.fascia,
        centileValue: item.footfallCentile
    }));
    const candidateTarget = useAppSelector(selectCandidateTarget);
    const storeCategoryCentilesMetrics = useAppSelector(selectStoreCategoryCentilesMetrics);
    const centileMetric = storeCategoryCentilesMetrics.find(cm => cm.centile === candidateTarget?.footfall);
    const name = !enableFootfallNew ? "Footfall level" : "Visits";
    const description = !enableFootfallNew ? "The yearly level of footfall through the retail centre." : "The average annual visits per cell in a retail centre.";
    const footfallCentileMetrics = [{
        name: !enableFootfallNew ? "Footfall level" : "Visits",
        tooltip: !enableFootfallNew
            ? "The yearly level of footfall through the retail centre."
            : "The average annual visits per cell in a retail centre. A retail centre is made up of several tessellating hexagons (cells) each covering ~0.015km² - comparable in size to Trafalgar Square, London.",
        value: numberFormatter.toDecimalPlaces(centileMetric?.footfallLevel ?? 0, 0)
    }];

    const handleSliderChange = (value: number) => {
        if (candidateTarget) {
            const newCandidateTarget = {
                ...candidateTarget,
                footfall: value
            };
            dispatch(setCandidateTarget(newCandidateTarget));
        }
    };

    if (!candidateTarget) {
        return null;
    }

    return (
        <Centile
            name={name}
            description={description}
            disabled={!candidateTarget.useFootfall}
            sliderValue={candidateTarget.footfall}
            onSliderChange={handleSliderChange}
            comparatorStoresCentiles={comparatorStoresCentiles}
            aggregatedDirectCompetitorCentiles={aggregatedDirectCompetitorCentiles}
            chartLowLabel="Very quiet area"
            chartHighLabel="Very busy area"
        >
            {footfallCentileMetrics.map((metric, index) =>
                <CentileMetric
                    key={index}
                    name={metric.name}
                    tooltip={metric.tooltip}
                    value={metric.value}
                    disabled={!candidateTarget.useFootfall}
                />
            )}
        </Centile>
    );
};

export default FootfallLevel;
